function Sip() {
  return (
    <div style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginTop: "200px",
      // minHeight: "calc(100vh - 140px)", // Adjust based on your nav+footer height
      // Example: if nav is 70px and footer is 70px, total is 140px
      textAlign: "center",
      padding: "20px"
    }}>
      <h1 style={{
        margin: 0,
        fontSize: "clamp(1.5rem, 5vw, 2.5rem)"
      }}>
        Summer Internship Portal is not open for registration right now, Please come back later.
      </h1>
    </div>
  );
}

export default Sip;
